import { render, staticRenderFns } from "./BackToTop.html?vue&type=template&id=e9994236&scoped=true&"
import script from "./BackToTop.js?vue&type=script&lang=js&"
export * from "./BackToTop.js?vue&type=script&lang=js&"
import style0 from "./BackToTop.scss?vue&type=style&index=0&id=e9994236&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9994236",
  null
  
)

export default component.exports